




























































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as _ from "lodash";
import axios, { resHandle } from "@/plugins/axios";
import wordcloud from "vue-wordcloud";
@Component({
  components: {
    wordcloud,
  },
})
export default class ExpertBianzhengResult extends Vue {
  @Prop()
  private cState: any;
  @Prop()
  private message: any;
  @Prop()
  private result: any;
  @Prop()
  private cFenxi: any;
  private ifShowFloatTab: boolean = false;
  private cloudLoaded: boolean = false;
  private fenbuOption: any = {};
  private blueColor: any[] = ["#1293D1"];
  private tupuOption: any = {
    series: [
      {
        type: "graph",
        layout: "force",
        force: {
          repulsion: 1000,
        },
        label: {
          show: true,
        },
      },
    ],
  };
  private graphLoaded: boolean = false;
  private sankeyLoaded: boolean = false;
  private teyixingOption: any = {
    series: [
      {
        type: "sankey",
        layout: "none",
        focusNodeAdjacency: "allEdges",
      },
    ],
  };
  @Watch("result", { immediate: true, deep: true })
  private resultChange() {
    if (this.cFenxi === "症状群") {
      this.createCiyun();
      this.createGraph();
    } else if (this.cFenxi === "症状特异性分析") {
      this.createSankey();
    }
  }
  /**
   * @description 切换分析方法
   */
  private typeChange(type) {
    this.$emit("typeChange", type);
  }
  /**
   * @description 监听根部滚动
   */
  private handleScroll() {
    const top = (this.$refs.root as any).scrollTop;
    if (top && top > 200) {
      this.ifShowFloatTab = true;
    } else {
      this.ifShowFloatTab = false;
    }
  }
  /**
   * @description 中医证型变化
   */
  private zhongyizhengxingChange(value) {
    this.$emit("zyzxChange", value);
  }
  /**
   * @description 症状群数据下载
   */
  private downloadZhengzhuangqun() {
    const load = this.$loading({
      text: "下载中...请稍后",
    });
    const params: any = _.cloneDeep(this.message);
    params.is_download = true;
    axios
      .post("api/wajue/zjbzjy/zzq", params)
      .then(({ data }) => {
        resHandle(this, data).then(() => {
          console.log(data);
          window.open(
            window.API_ROOT +
              "api/wajue/download?filename=" +
              data.data.file_name
          );
        });
      })
      .finally(() => {
        load.close();
      });
  }
  /**
   * @description 生成词云
   */
  private createCiyun() {
    this.cloudLoaded = true;
  }
  /**
   * @description 生成关系图
   */
  private createGraph() {
    this.tupuOption.series[0].data = this.result["症证图谱"]["nodes"];
    this.tupuOption.series[0].categories = this.result["症证图谱"][
      "categories"
    ];
    this.tupuOption.series[0].links = this.result["症证图谱"]["links"];
    this.tupuOption.series[0].symbolSize = (value: any) => {
      return value;
    };
    this.graphLoaded = true;
  }
  /**
   * @description 生成桑基图
   */
  private createSankey() {
    console.log(this.result);

    this.teyixingOption.series[0].data = this.result["症状特异性分析"]["nodes"];
    this.teyixingOption.series[0].links = this.result["症状特异性分析"][
      "links"
    ];
    this.sankeyLoaded = true;
  }
  /**
   * @description 特异性导出数据
   */
  private downloadTeyixing(name) {
    const load = this.$loading({
      text: "下载中...请稍后",
    });
    const params: any = _.cloneDeep(this.message);
    params.is_download = true;
    params.download_name = name;
    axios
      .post("api/wajue/zjbzjy/zzty", params)
      .then(({ data }) => {
        resHandle(this, data).then(() => {
          console.log(data);
          window.open(
            window.API_ROOT +
              "api/wajue/download?filename=" +
              data.data.file_name
          );
        });
      })
      .finally(() => {
        load.close();
      });
  }
}
